var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.492 13.435c.207 0 .39-.066.58-.257l2.79-2.69a.664.664 0 0 0-.465-1.154.694.694 0 0 0-.515.233l-1.17 1.237-.531.606.083-1.229V1.573a.773.773 0 0 0-.772-.755.77.77 0 0 0-.764.755v8.608l.083 1.237-.54-.614L6.11 9.567a.712.712 0 0 0-.523-.233.664.664 0 0 0-.68.665c0 .199.083.348.224.49l2.789 2.689c.19.19.373.257.573.257Zm-4.773 5.379h9.554c1.793 0 2.723-.921 2.723-2.69V7.949c0-1.768-.93-2.69-2.723-2.69h-2.25v1.628h2.15c.764 0 1.196.398 1.196 1.203v7.894c0 .806-.432 1.204-1.196 1.204H3.818c-.772 0-1.195-.398-1.195-1.204V8.09c0-.805.423-1.203 1.195-1.203h2.167V5.259H3.719c-1.793 0-2.723.921-2.723 2.69v8.176c0 1.768.93 2.689 2.723 2.689Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.7ffbcf513ff8a1fef176abf8409e9aaf.svg";
export { ForwardRef as ReactComponent };